import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      nav: {
        services: 'Servicios',
        pricing: 'Precios',
        about: 'Nosotros',
        contact: 'Contacto'
      },
      hero: {
        title: 'Revoluciona tu Centro de Contacto',
        subtitle: 'con Inteligencia Artificial',
        description: 'Soluciones avanzadas de call center, SMS, IA conversacional y análisis predictivo para empresas que buscan excelencia en atención al cliente',
        cta: 'Solicita una Demo',
        ctaSecondary: 'Ver Servicios',
        stats: {
          calls: 'Llamadas/día',
          satisfaction: 'Satisfacción',
          efficiency: 'Más Eficiencia'
        }
      },
      services: {
        title: 'Nuestros Servicios',
        subtitle: 'Soluciones innovadoras para cada necesidad',
        cta: 'Solicitar Información',
        categories: {
          all: 'Todos',
          core: 'Servicios Core',
          ai: 'Inteligencia Artificial',
          analytics: 'Analytics',
          security: 'Seguridad',
          specialized: 'Especializados'
        }
      },
      pricing: {
        title: 'Calculadora de Precios',
        subtitle: 'Calcula el costo estimado de tu solución',
        selectService: 'Selecciona un servicio',
        agents: 'Número de agentes',
        lines: 'Número de líneas',
        monthlyCalls: 'Llamadas mensuales',
        monthlySms: 'SMS mensuales',
        calculate: 'Calcular Precio',
        result: {
          setup: 'Costo de Instalación',
          monthly: 'Costo Mensual',
          details: 'Detalles del Cálculo'
        }
      },
      contact: {
        title: 'Contáctanos',
        subtitle: 'Estamos aquí para ayudarte',
        form: {
          name: 'Nombre completo',
          email: 'Correo electrónico',
          phone: 'Teléfono',
          company: 'Empresa (opcional)',
          service: 'Servicio de interés',
          message: 'Mensaje',
          submit: 'Enviar Mensaje',
          success: '¡Mensaje enviado! Te contactaremos pronto.',
          error: 'Error al enviar el mensaje. Intenta nuevamente.'
        },
        info: {
          email: 'Email',
          phone: 'Teléfono',
          hours: 'Horario',
          hoursValue: 'Lun - Vie: 9:00 - 18:00'
        }
      },
      features: {
        title: 'Por qué elegirnos',
        subtitle: 'Ventajas competitivas que nos hacen únicos',
        items: {
          ai: {
            title: 'IA Avanzada',
            description: 'Tecnología de inteligencia artificial de última generación'
          },
          support: {
            title: 'Soporte 24/7',
            description: 'Asistencia técnica disponible en todo momento'
          },
          integration: {
            title: 'Integración Fácil',
            description: 'Conecta con tus sistemas existentes sin complicaciones'
          },
          security: {
            title: 'Máxima Seguridad',
            description: 'Encriptación bancaria y cumplimiento normativo'
          },
          scalable: {
            title: 'Escalable',
            description: 'Crece con tu negocio sin límites'
          },
          analytics: {
            title: 'Analytics Avanzado',
            description: 'Insights en tiempo real para mejores decisiones'
          }
        }
      },
      footer: {
        description: 'Líder en soluciones de contact center y telecomunicaciones con IA',
        quickLinks: 'Enlaces Rápidos',
        services: 'Servicios',
        legal: 'Legal',
        privacy: 'Aviso de privacidad',
        terms: 'Condiciones del servicio',
        dataDeletion: 'Eliminación de datos',
        rights: 'Todos los derechos reservados',
        entity: 'Call Market es un producto desarrollado por ACXOR, una marca comercial de FORTIA SYSTEMS, S.A. de C.V.'
      }
    }
  },
  en: {
    translation: {
      nav: {
        services: 'Services',
        pricing: 'Pricing',
        about: 'About',
        contact: 'Contact'
      },
      hero: {
        title: 'Revolutionize your Contact Center',
        subtitle: 'with Artificial Intelligence',
        description: 'Advanced call center, SMS, conversational AI and predictive analytics solutions for companies seeking excellence in customer service',
        cta: 'Request a Demo',
        ctaSecondary: 'View Services',
        stats: {
          calls: 'Calls/day',
          satisfaction: 'Satisfaction',
          efficiency: 'More Efficiency'
        }
      },
      services: {
        title: 'Our Services',
        subtitle: 'Innovative solutions for every need',
        cta: 'Request Information',
        categories: {
          all: 'All',
          core: 'Core Services',
          ai: 'Artificial Intelligence',
          analytics: 'Analytics',
          security: 'Security',
          specialized: 'Specialized'
        }
      },
      pricing: {
        title: 'Price Calculator',
        subtitle: 'Calculate the estimated cost of your solution',
        selectService: 'Select a service',
        agents: 'Number of agents',
        lines: 'Number of lines',
        monthlyCalls: 'Monthly calls',
        monthlySms: 'Monthly SMS',
        calculate: 'Calculate Price',
        result: {
          setup: 'Setup Cost',
          monthly: 'Monthly Cost',
          details: 'Calculation Details'
        }
      },
      contact: {
        title: 'Contact Us',
        subtitle: 'We are here to help you',
        form: {
          name: 'Full name',
          email: 'Email address',
          phone: 'Phone',
          company: 'Company (optional)',
          service: 'Service of interest',
          message: 'Message',
          submit: 'Send Message',
          success: 'Message sent! We will contact you soon.',
          error: 'Error sending message. Please try again.'
        },
        info: {
          email: 'Email',
          phone: 'Phone',
          hours: 'Hours',
          hoursValue: 'Mon - Fri: 9:00 AM - 6:00 PM'
        }
      },
      features: {
        title: 'Why choose us',
        subtitle: 'Competitive advantages that make us unique',
        items: {
          ai: {
            title: 'Advanced AI',
            description: 'State-of-the-art artificial intelligence technology'
          },
          support: {
            title: '24/7 Support',
            description: 'Technical assistance available at all times'
          },
          integration: {
            title: 'Easy Integration',
            description: 'Connect with your existing systems hassle-free'
          },
          security: {
            title: 'Maximum Security',
            description: 'Banking encryption and regulatory compliance'
          },
          scalable: {
            title: 'Scalable',
            description: 'Grow with your business without limits'
          },
          analytics: {
            title: 'Advanced Analytics',
            description: 'Real-time insights for better decisions'
          }
        }
      },
      footer: {
        description: 'Leader in AI-powered contact center and telecommunications solutions',
        quickLinks: 'Quick Links',
        services: 'Services',
        legal: 'Legal',
        privacy: 'Privacy',
        terms: 'Terms',
        dataDeletion: 'Data deletion',
        rights: 'All rights reserved',
        entity: 'Call Market is a product developed by ACXOR, a trade name of FORTIA SYSTEMS, S.A. de C.V.'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
